import { app } from '../../../../app';
import { Controller } from './choose-shared-folder.controller';

app.component('companySharingCenterSharedFoldersChoose', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./choose-shared-folder.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/choose-folder/choose-shared-folder.component.js